/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Sample_DayInputs */

const en_features_sample_day = /** @type {(inputs: Features_Sample_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upper A`)
};

const pl_features_sample_day = /** @type {(inputs: Features_Sample_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Góra A`)
};

/**
* | output |
* | --- |
* | "Upper A" |
*
* @param {Features_Sample_DayInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_sample_day = /** @type {((inputs?: Features_Sample_DayInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Sample_DayInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_sample_day(inputs)
	return en_features_sample_day(inputs)
});